<template>
  <v-row class="add-client-form no-padding">
    <successModal ref="success_modal" v-on:confirm="sendMail"></successModal>
    <errorDialog ref="error_modal" v-on:confirm="closeErrorModal"></errorDialog>
    <div class="col-md-12 form-row-60-height">
      <div class="row">
        <div class="col-md-12">
          <h3 class="form-title font">Add & Invite a User</h3>
        </div>
      </div>
      <v-form v-model.trim="valid" ref="form" class="row">
        <div class="col-lg-6 col-xl-6 col-md-12 pb-0">
          <label class="font text-gray" for="">First Name</label>
          <v-text-field
            required
            v-model.trim="firstName"
            solo
            :rules="requiredRules"
            tabindex="1"
          ></v-text-field>
        </div>
        <div class="col-lg-6 col-xl-6 col-md-12 pb-0">
          <label class="font text-gray" for=""
            >Location(s)
            <span class="small-text font-italic ml-3"
              >(select one or more locations)</span
            >
          </label>
          <v-select
            v-model="locations"
            multiple
            item-text="name"
            item-value="id"
            :items="allLocations"
            required
            tabindex="6"
            solo
          ></v-select>
        </div>
        <div class="col-lg-6 col-xl-6 col-md-12 pb-0 pt-0">
          <label class="font text-gray" for="">Last Name</label>
          <v-text-field
            required
            tabindex="2"
            :rules="requiredRules"
            v-model.trim="lastName"
            solo
          ></v-text-field>
        </div>
        <div class="col-lg-6 col-xl-6 col-md-12 pb-0 pt-0">
          <label class="font text-gray" for="">Role </label>
          <v-select
            required
            tabindex="5"
            solo
            :rules="requiredRules"
            :items="roles"
            v-model.trim="role"
          ></v-select>
        </div>
        <div class="col-lg-6 col-xl-6 col-md-12 pb-0 pt-0">
          <label class="font text-gray" for="">Email</label>
          <v-text-field
            required
            :rules="emailRules"
            @blur="validateEmail(email)"
            :error-messages="emailError"
            v-model.trim="email"
            solo
            tabindex="3"
          ></v-text-field>
        </div>
        <!-- <div class="col-md-6 pb-0 pt-0">
          <label class="font text-gray" for="">Address</label>
          <v-text-field
            required
            tabindex="7"
            :rules="requiredRules"
            v-model.trim="address"
            solo
          ></v-text-field>
        </div> -->
        <div class="col-md-6 pb-0 pt-0">
          <label class="font text-gray" for="">Title</label>
          <v-text-field
            required
            tabindex="4"
            :rules="requiredRules"
            v-model.trim="title"
            solo
          ></v-text-field>
        </div>
        <!-- <div class="col-lg-6 col-xl-6 col-md-12 row no-padding">
          <div class="col-md-6 pb-0 pt-0">
            <label class="font text-gray" for="">City</label>
            <v-text-field
              required
              :rules="requiredRules"
              v-model.trim="city"
              solo
              tabindex="8"
            ></v-text-field>
          </div>
          <div class="col-md-3 pb-0 pt-0">
            <label class="font text-gray" for="">State</label>
            <v-select
              required
              :rules="requiredRules"
              :items="states"
              v-model.trim="state"
              solo
              tabindex="9"
              item-text="name"
              item-value="name"
            ></v-select>
          </div>
          <div class="col-md-3 pb-0 pt-0">
            <label class="font text-gray" for="">Zip</label>
            <v-text-field
              required
              type="number"
              v-model.trim="zip"
              :rules="zipRules"
              solo
              tabindex="10"
            ></v-text-field>
          </div>
        </div> -->
      </v-form>
    </div>
    <div class="row text-end justify-end no-padding pr-10">
      <div class="col-md-12 mt-4 mb-4 pt-8 gray-underline-wizard margin-l-11">
        <span
          class="text-underline col-md-12  pointer"
          style="color: #0572f3"
          @click="$router.push(`/dpc-providers/users`)"
          >Cancel</span
        >
        <span
          class="text-underline ml-10 mr-2 col-md-12 pointer"
          style="color: #0572f3"
          @click="save()"
          >Save & Invite User</span
        >
      </div>
    </div>
  </v-row>
</template>
<script>
import successModal from "../../../../TablesTemplate/SuccessDialog.vue";
import errorDialog from "../../../../TablesTemplate/ErrorDialog.vue";
import api from "../../../../../services/api";
export default {
  components: { successModal, errorDialog },
  data() {
    return {
      emailError: "",
      firstName: "",
      lastName: "",
      email: "",
      title: "",
      role: "",
      officeName: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      roles: [],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-mail must be valid",
      ],
      requiredRules: [(v) => !!v || "This field is required"],
      zipRules: [
        (v) => (v && v.length == 5) || " Zip Code should be five digits long",
      ],
      states: [],
      valid: false,
      allLocations: [],
      locations: [],
    };
  },
  computed: {
    routeParams() {
      return this.$route.params.name;
    },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getStates();
    this.getLocations();
    this.getRoles();
  },
  methods: {
    getLocations() {
      api()
        .get("/dpcproviders/locations")
        .then((res) => {
          this.allLocations = res.data;
        });
    },
    getRoles() {
      api()
        .get("/roles")
        .then((res) => {
          if (this.user.role == "moderator") {
            res.data.forEach((el) => {
              this.roles.push(el.name);
            });

            let moderator = this.roles.pop("admin");
          } else {
            res.data.forEach((el) => {
              this.roles.push(el.name);
            });
          }
        });
    },
    getStates() {
      api()
        .get("/api/states")
        .then((res) => {
          res.data.forEach((el) => {
            if (el.active) {
              this.states.push(el);
            }
          });
        });
    },
    sendMail() {
      this.$refs.success_modal.closePopUp();
      this.$parent.getAllUsers();
      this.$router.push(`/dpc-providers/users`);
    },
    closeErrorModal() {
      this.$refs.error_modal.closePopUp();
    },
    validateEmail(email){
      api()
          .post(`/dpcproviders/user/validate/email`, {email : email})
          .catch((err) => {
           console.log('err',err.response.data)
          })
          .then((res) => {
            if (res) {
             if(res.data.valid == false){
              this.emailError = res.data.reason;
             }
             else{
              this.emailError = "";
             }
            }
          });
    },
    save() {
      this.$refs.form.validate();
      if (this.valid) {
        let data = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          title: this.title,
          role: this.role,
          // officeName: this.officeName,
          // address1: this.address,
          // city: this.city,
          // state: this.state,
          // zipCode: this.zip,
          locations: this.locations,
        };
        api()
          .post(`/dpcproviders/users`, data)
          .catch((err) => {
            if (err.response.status == 500) {
              this.$refs.error_modal.openPopUp(
                "There was an error, system admin is notified. Please try again later."
              );
            } else {
              this.$refs.error_modal.openPopUp(err.response.data);
            }
          })
          .then((res) => {
            if (res) {
              this.$refs.success_modal.openPopUp(res.data);
            }
          });
      }
    },
  },
};
</script>
<style>
.form-row-60-height {
  min-height: 70vh;
}
</style>